import { createFileRoute } from "@tanstack/react-router";
import { QrCode, Download, BarChart3 } from "lucide-react";
import { FeaturePage } from "@/components/marketing/FeaturePage";
import { alternateLinkList } from "@/lib/i18n/locale";
import walletAsset from "@/assets/platform/networking/qr-code/virtual-cards.webp.asset.json";
import qrToolAsset from "@/assets/platform/networking/qr-code/qr-code.webp.asset.json";
import analyticsAsset from "@/assets/platform/networking/qr-code/qr-analytics.webp.asset.json";

const heroImg = walletAsset.url;
const heroAlt = "Danh thiếp ảo Banana của Noah Spinner, Sales Manager tại ACME Inc, lưu trong ứng dụng Apple Wallet trên iPhone kèm QR code có thể quét";
const qrToolImg = qrToolAsset.url;
const qrToolAlt = "Bảng Networking Tools của Banana trên MacBook hiển thị trình chỉnh QR Code branded cùng Contact Exchange, Welcome Email, Add to Wallet và bảo vệ PIN";
const analyticsImg = analyticsAsset.url;
const analyticsAlt = "Dashboard analytics Banana trên MacBook thống kê nguồn traffic QR code và NFC tap, thẻ hiệu quả nhất, loại thiết bị, trình duyệt, địa lý và thời gian scan";

export const Route = createFileRoute("/vi/platform/networking/qr-code")({
  head: () => ({
    meta: [
      { title: "QR Code động — banana.cards" },
      { name: "description", content: "QR branded cho mọi thẻ. Đổi đích đến bất kỳ lúc nào, theo dõi mọi scan, download PNG hoặc SVG." },
      { property: "og:title", content: "QR Code động — banana.cards" },
      { property: "og:description", content: "QR branded, re-route bất kỳ lúc nào." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/networking/qr-code", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <FeaturePage
      eyebrow="QR Code"
      title="Một mã,"
      italic="mọi kênh."
      description="Tạo QR branded, động cho mọi thẻ. Re-route đích đến bất kỳ lúc nào, theo dõi mọi scan, và download file print-ready PNG hoặc SVG."
      heroImage={heroImg}
      heroImageAlt={heroAlt}
      metrics={[{ v: "Động", l: "QR" }, { v: "PNG · SVG", l: "download" }, { v: "Live", l: "scan stats" }]}
      bullets={[
        { icon: QrCode, title: "QR branded", desc: "Màu tùy chỉnh, logo ở giữa và module bo tròn — QR của bạn, không phải ô vuông đen chung chung." },
        { icon: Download, title: "Print-ready", desc: "Download PNG độ phân giải cao hoặc SVG vector cho sticker, signage, name tag và merch." },
        { icon: BarChart3, title: "Theo dõi mọi scan", desc: "Tổng scan, thiết bị unique, vị trí, thời gian — mỗi QR, thời gian thực." }
      ]}
      deepDives={[
        { eyebrow: "Động", title: "Đổi link,", italic: "giữ QR.", description: "QR Banana là động — trỏ cùng một mã sang đích mới bất cứ lúc nào không cần in lại.", image: qrToolImg, imageAlt: qrToolAlt, reverse: false, points: ["Re-route bất cứ lúc nào", "A/B test đích đến", "QR biến thể theo sự kiện", "Ổn định theo thời gian"] },
        { eyebrow: "Analytics", title: "Mỗi scan,", italic: "được attribute.", description: "Xem chính xác QR scan ở đâu và khi nào. Gắn với sự kiện, kênh và campaign với UTM passthrough.", image: analyticsImg, imageAlt: analyticsAlt, reverse: true, points: ["Scan theo thành phố & device", "Pattern theo giờ", "UTM passthrough", "Export CSV & API"] }
      ]}
      howItWorks={[
        { title: "Tạo QR", desc: "1 click từ thẻ bất kỳ." },
        { title: "Brand nó", desc: "Màu, logo, góc bo tròn." },
        { title: "Download & share", desc: "PNG hoặc SVG cho print và digital." },
        { title: "Track & re-route", desc: "Xem scan, swap đích đến." }
      ]}
      capabilities={["QR động", "Màu & logo tùy chỉnh", "Export PNG & SVG", "QR mỗi thẻ", "Analytics scan thời gian thực", "Geo & device insights", "UTM passthrough", "URL ổn định — không in lại"]}
      faq={[
        { q: "QR tĩnh vs động khác nhau thế nào?", a: "QR tĩnh có URL nhúng cứng — in xong khoá vĩnh viễn. QR động (Banana tạo) trỏ qua short redirect bạn kiểm soát — re-route bất cứ lúc nào." },
        { q: "Có thêm logo branded được không?", a: "Có — drop logo vào giữa, đặt màu, chọn module bo tròn hoặc vuông, download với frame và CTA tùy chỉnh." },
        { q: "Format file export nào?", a: "PNG độ phân giải cao, SVG vector và PDF print-ready." },
        { q: "Theo dõi được ai scan QR không?", a: "Có — mỗi scan được log với timestamp, vị trí, device và nguồn." }
      ]}
      outro={{ title: "In một lần.", italic: "Re-route mãi mãi.", description: "QR động cho sự kiện, signage và chia sẻ hàng ngày." }}
    />
  );
}